'use strict'

Vue.component('awe-dropdown', {
  props: {
    items: {type: Array, default: []},
    defaultIdx: {type: Number, default: 0},
    itemLabel: {type: [String, Function], default: 'label'},
    listId: {type: String, default: ''},
    name: {type: String, default: ''},
    useImg:{type: Boolean, default: true},
    wrap: {type: Boolean, default: true},
  },
  data: function(){
    return {
      expanded: false, // true to show dropdown
      curIdx: -1, // current index
      i18n: window.i18n,
      selectedIdx: 0,
    }
  },
  computed: {
    selectedItem: function(){
      if (this.selectedIdx > -1)
        return this.items[this.selectedIdx]
      else if (this.defaultIdx >= 0 && this.defaultIdx < this.items.length)
        return this.items[this.defaultIdx]
      else return null
    },
    currentLabel: function(){
      let lbl = ''
      if (this.selectedItem){
        switch (typeof this.itemLabel){
          case 'string':
            lbl = this.selectedItem[this.itemLabel] || ''
            break
          case 'function':
            lbl = this.itemLabel.call(null, this.selectedItem) || ''
        }
      }
      return lbl
    }
  },
  watch:{
    defaultIdx: {
      handler: function(value){
        this.curIdx = value
        this.selectedIdx = value
      },
      immediate: true
    },
    items: function(){
      this.curIdx = this.defaultIdx
      this.selectedIdx = this.defaultIdx
    }
  },
  methods: {
    // show/hide dropdown list
    toggle: function(e){
      this.expanded = !this.expanded
      if (this.expanded){
        this.$el.focus()
        this.curIdx = this.selectedIdx
        setTimeout(()=>{ this.scrollToCurentRow() }, 100)
        if (this.listId)
          Tracker.dropTag('ddnOpen', {list: this.listId})
      }
    },

    getLabel: function(item){
      let lbl = ''
      if (item){
        switch (typeof this.itemLabel){
          case 'string':
            lbl = item[this.itemLabel] || ''
            break
          case 'function':
            lbl = this.itemLabel.call(null, item) || ''
        }
      }
      return lbl
    },

    scrollToCurentRow: function(){
      const nd = this.$el.querySelector('#i'+ this.curIdx)
      if (nd)
        nd.scrollIntoView({ behavior: 'auto', block: 'nearest' })
    },

    // mouse selection event handler
    select: function(e, item){
      if (e.type === 'mouseup' && e.which !== 1) // left-click only, right-click/wheel-click not supported
        return

      this._select(this.curIdx)
      this.expanded = false
    },

    _select: function(idx){
      const cleanIdx = Math.max(0, Math.min(idx, this.items.length-1))
      if (cleanIdx != this.selectedIdx)
        this._triggerSelect(cleanIdx)
    },

    // actual selection: assign property, emits event and drops tracking.
    _triggerSelect: function(newIdx){
      this.selectedIdx = newIdx
      this.$emit('change', this.items[newIdx])
      if (this.listId)
        Tracker.dropTag('ddnChange', {list: this.listId, value: this.items[newIdx]?.value})
    },

    _onmouseover: function(e, idx){
      this.curIdx = idx
    },

    onKeyDown: function(e){
      if (this.expanded)
        e.stopPropagation()

      switch(e.key){
        case 'Enter':
          if (this.expanded && this.curIdx !== -1)
            this._triggerSelect(this.curIdx)
          this.toggle()
          break
        case 'Escape':
          if (this.expanded)
            this.toggle()
          break
        case 'ArrowUp':
          if (this.expanded){
            this.curIdx = Math.max(--this.curIdx, 0)
            this.scrollToCurentRow()
          }
          else
            this._select(this.selectedIdx - 1)
          e.preventDefault()
          break
        case 'ArrowDown':
          if (this.expanded){
            this.curIdx = Math.min(++this.curIdx, this.items.length - 1)
            this.scrollToCurentRow()
          }
          else
            this._select(this.selectedIdx + 1)
          e.preventDefault()
          break
        case 'ArrowLeft':
          if (!this.expanded)
            this._select(this.selectedIdx - 1)
          e.preventDefault()
          break
        case 'ArrowRight':
          if (!this.expanded)
            this._select(this.selectedIdx + 1)
          e.preventDefault()
          break
      }
    }
  },

  template: `
    <div class="dropdown" role="combobox" aria-haspopup="listbox" :aria-expanded="expanded.toString()" :aria-controls="(listId || name) ? (listId || name) + '-listbox' : null" :class="{expanded: expanded}" v-on:blur="expanded = false"
        v-on:keydown.up.down.left.right="onKeyDown" v-on:keyup.esc.enter="onKeyDown"
        tabindex="0" :aria-label="i18n.getString('DROPDOWN_ARIA_LABEL', {name: name || listId})"
        :aria-activedescendant="'i' + curIdx"
    >

      <div class="selection row" v-on:click="toggle" :aria-label="currentLabel" v-if="selectedItem" role="button">
        <slot name="selection" :item="selectedItem" :expanded="expanded">
          <div class="img-ctnr" role="presentation" v-if="selectedItem && useImg">
            <img loading="lazy" v-show="selectedItem.thumbImgUrl || selectedItem.imgUrl" :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(selectedItem.thumbImgUrl || selectedItem.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1'"
              :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(selectedItem.thumbImgUrl || selectedItem.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1 1x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(selectedItem.thumbImgUrl || selectedItem.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1 1.5x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(selectedItem.thumbImgUrl || selectedItem.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1 2x, ' +
                      'https://img.static-swaven.com/v7/' + encodeURIComponent(selectedItem.thumbImgUrl || selectedItem.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1 3x'"
              :title="currentLabel" :alt="currentLabel">

          </div>
          <div class="info" :title="getLabel(selectedItem)" aria-live="polite">
            {{ getLabel(selectedItem) }}
          </div>
        </slot>

        <slot name="arrow" :expanded="expanded">
          <svg  class="arrow" :class="{expanded}" viewBox="0 0 25 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 1a2.1213 2.6517 45 013 3L14 14a2 2.1 0 01-3 0L1 4a2.6517 2.1213 45 013.0988-2.9012l8.5 8.5z" />
          </svg>
        </slot>
      </div>

      <transition name="rolldown">
      <div class="opts-ctnr" v-show="expanded">
        <ol class="opts" :class="{wrap: wrap}" role="listbox" aria-orientation="vertical" :id="(listId || name) ? (listId || name) + '-listbox' : null">
          <li v-for="(item, i) in items" class="row"
            :class="{hover: curIdx === i}" role="option"
            :id="'i'+i"
            :aria-current="(i === curIdx).toString()"
            :aria-selected="(i === selectedIdx).toString()"
            :aria-label="getLabel(item)"
            @mouseup="select($event, item)"
            @mousedown="$event.preventDefault()"
            @mouseover="_onmouseover($event, i)"
          >

            <slot name="option" :item="item">
              <div class="img-ctnr" v-if="useImg">
              <img loading="lazy" v-show="item.thumbImgUrl || item.imgUrl" :src="'https://img.static-swaven.com/v7/' + encodeURIComponent(item.thumbImgUrl || item.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1'"
                :srcset="'https://img.static-swaven.com/v7/' + encodeURIComponent(item.thumbImgUrl || item.imgUrl) + '?width=200&org_if_sml=1&ci_url_encoded=1 1x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(item.thumbImgUrl || item.imgUrl) + '?width=300&org_if_sml=1&ci_url_encoded=1 1.5x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(item.thumbImgUrl || item.imgUrl) + '?width=400&org_if_sml=1&ci_url_encoded=1 2x, ' +
                        'https://img.static-swaven.com/v7/' + encodeURIComponent(item.thumbImgUrl || item.imgUrl) + '?width=600&org_if_sml=1&ci_url_encoded=1 3x'"
                :title="getLabel(item)" :alt="getLabel(item)">
              </div>
              <div class="info">{{ getLabel(item) }}</div>
            </slot>
          </li>
        </ol>
      </div>
      </transition>
      <div id="ta-announce">{{currentLabel}}</div>
    </div>
  `
})
